import React from 'react';
import { TablePagination } from '@mui/material';

interface PaginationControlsProps {
  page: number;
  total: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
}

export default function PaginationControls({
  page,
  total,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: PaginationControlsProps) {
  return (
    <TablePagination
      component="div"
      count={total}
      page={page - 1}
      onPageChange={(_, nextPage) => onPageChange(nextPage + 1)}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={(event) => onRowsPerPageChange(Number(event.target.value))}
      rowsPerPageOptions={[10, 20, 50]}
      labelRowsPerPage="Rows per page"
    />
  );
}
